import { UpdatableConfig } from './types/config.mjs';

/** The AlgoKit config. To update it use the configure method. */
const Config = new UpdatableConfig();

export { Config };
//# sourceMappingURL=config.mjs.map
